<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main material-modal">
      <div class="title-area" id="modal-moving">
        <h2>素材空間設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="main-area">
        <div class="data-area">
          <span>{{ spaceObjName + '（id:' + focusedMenuSpace.id + '）'}}</span>
          <ul>
            <li>
              <div class="label">①{{faceData.face1.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.surfaceMaterial"
                    :value="1"
                  />有効
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.surfaceMaterial"
                    :value="0"
                    :disabled="checkDisableRadio(form.surfaceMaterial, form.surfaceId)"
                  />無効
                </label>
              </div>
            </li>
            <li>
              <div class="label">②{{faceData.face2.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.backMaterial"
                    :value="1"
                    :disabled="checkDisableRadio(form.backMaterial, form.backId)"
                  />有効
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.backMaterial"
                    :value="0"
                    :disabled="checkDisableRadio(form.backMaterial, form.backId)"
                  />無効
                </label>
              </div>
            </li>
            <li>
              <div class="label">③{{faceData.face3.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial1"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberMaterial1, form.lumber1Id)"
                  />有効
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial1"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberMaterial1, form.lumber1Id)"
                  />無効
                </label>
              </div>
            </li>
            <li>
              <div class="label">④{{faceData.face4.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial2"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberMaterial2, form.lumber2Id)"
                  />有効
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial2"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberMaterial2, form.lumber2Id)"
                  />無効
                </label>
              </div>
            </li>
            <li>
              <div class="label">⑤{{faceData.face5.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial3"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberMaterial3, form.lumber3Id)"
                  />有効
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial3"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberMaterial3, form.lumber3Id)"
                  />無効
                </label>
              </div>
            </li>
            <li>
              <div class="label">⑥{{faceData.face6.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial4"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberMaterial4, form.lumber4Id)"
                  />有効
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberMaterial4"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberMaterial4, form.lumber4Id)"
                  />無効
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="preview-area">
          <div class="face-area">
            <svg :width="this.svgSize" :height="this.svgSize" :viewBox="dispViewBox">
              <!-- パーツ -->
              <rect
                :x="(this.svgSize - previewData.width) / 2"
                :y="(this.svgSize - previewData.height) / 2"
                :width="previewData.width"
                :height="previewData.height"
                stroke="black"
                fill="white"
              />
              <!-- 木目No -->
              <g
                v-for="(num, index) in firstNumberList"
                :key="'num' + index"
              >
               <text :x="num.x" :y="num.y" :font-size="fontSize">{{num.label}}</text>
              </g>
            </svg>
            <div class="face-name">
              <span>{{ faceData.face1.name }}</span>
            </div>
          </div>
          <div class="face-area">
            <svg :width="this.svgSize" :height="this.svgSize" :viewBox="dispViewBox">
              <!-- パーツ -->
              <rect
                :x="(this.svgSize - previewData.width) / 2"
                :y="(this.svgSize - previewData.height) / 2"
                :width="previewData.width"
                :height="previewData.height"
                stroke="black"
                fill="white"
              />
              <!-- 木目No -->
              <g
                v-for="(num, index) in secondNumberList"
                :key="'num' + index"
              >
               <text :x="num.x" :y="num.y" :font-size="fontSize">{{num.label}}</text>
              </g>
            </svg>
            <div class="face-name">
              <span>{{ faceData.face2.name }}</span>
            </div>
          </div>
        </div>
        <div class="errormessage-area">
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updateMaterial">登録</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {ATTRIBUTE_KEY} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import * as SpaceUtil from '../../../utils/Space'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetMaterialModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    focusedMenuSpace: Object
  },
  data () {
    return {
      modalShown: false,
      form: {
        spaceId: '',
        surfaceId: '',
        surfaceMaterial: '',
        backId: '',
        backMaterial: '',
        lumber1Id: '',
        lumberMaterial1: '',
        lumber2Id: '',
        lumberMaterial2: '',
        lumber3Id: '',
        lumberMaterial3: '',
        lumber4Id: '',
        lumberMaterial4: ''
      },
      /** 選択空間 */
      selectedSpace: {},
      /** 選択空間オブジェクト名 */
      spaceObjName: '',
      /** アトリビュート情報 */
      dirAtt: {},
      /** プレビュー表示用データ */
      previewData: {
        width: '',
        height: '',
        processX: '',
        processY: '',
        processRX: '',
        processRY: '',
        processW: '',
        processH: ''
      },
      /** プレビュー表示エリアサイズ */
      svgSize: 350,
      /** プレビュー縮尺率 */
      previewRatio: 1,
      /** フォントサイズ */
      fontSize: 12,
      /** 表示対象面 */
      faceData: {
        face1: {
          name: '',
          code: '',
          objName: ''
        },
        face2: {
          name: '',
          code: '',
          objName: ''
        },
        face3: {
          name: '',
          code: '',
          objName: ''
        },
        face4: {
          name: '',
          code: '',
          objName: ''
        },
        face5: {
          name: '',
          code: '',
          objName: ''
        },
        face6: {
          name: '',
          code: '',
          objName: ''
        }
      },
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    dispViewBox: function () {
      return 0 + ' ' + 0 + ' ' + this.svgSize + ' ' + this.svgSize
    },
    firstNumberList: function () {
      return this.createNumberList(true)
    },
    secondNumberList: function () {
      return this.createNumberList(false)
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** 素材空間設定モーダル表示 */
    showModal: function () {
      this.clearData()
      this.form.spaceId = this.focusedMenuSpace.id
      this.getPartsData()
      this.showPartsPreview()
      this.modalShown = true
    },
    /** モーダルキャンセル */
    onCancel: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** パーツ情報の取得 */
    getPartsData: function () {
      this.selectedSpace = SpaceUtil.searchSpaceTree(this.form.spaceId, this.fileData.topSpaceModel)
      this.dirAtt = this.fileData.attributeModelList.find(att => {
        return att.attKeycd === ATTRIBUTE_KEY.PT_FLAG_DIR && att.spaceId === this.form.spaceId
      })
      this.spaceObjName = this.fileData.objectDataModelList.find(obj => {
        return obj.spaceId === this.form.spaceId
      }).objName
      // 表示用の面の設定
      switch (this.dirAtt.attValue1) {
        case 1:
          this.faceData.face1 = {name: '上面', code: 3}
          this.faceData.face2 = {name: '下面', code: 4}
          this.faceData.face3 = {name: '後面', code: 6}
          this.faceData.face4 = {name: '右面', code: 1}
          this.faceData.face5 = {name: '前面', code: 5}
          this.faceData.face6 = {name: '左面', code: 2}
          break
        case 2:
          this.faceData.face1 = {name: '左面', code: 2}
          this.faceData.face2 = {name: '右面', code: 1}
          this.faceData.face3 = {name: '上面', code: 3}
          this.faceData.face4 = {name: '前面', code: 5}
          this.faceData.face5 = {name: '下面', code: 4}
          this.faceData.face6 = {name: '後面', code: 6}
          break
        case 3:
          this.faceData.face1 = {name: '前面', code: 5}
          this.faceData.face2 = {name: '後面', code: 6}
          this.faceData.face3 = {name: '上面', code: 3}
          this.faceData.face4 = {name: '右面', code: 1}
          this.faceData.face5 = {name: '下面', code: 4}
          this.faceData.face6 = {name: '左面', code: 2}
          break
        default:
      }
      this.getMaterialData()
    },
    /** 素材情報情報の取得 */
    getMaterialData: function () {
      let objectList = []
      axios.get(API_URL.PLANNING + '/object/' + this.focusedMenuSpace.id)
        .then(response => {
          objectList = response.data.data
          objectList.forEach(obj => {
            switch (obj.objElFaceType) {
              case this.faceData.face1.code:
                this.form.surfaceId = obj.spaceId
                this.form.surfaceMaterial = obj.objEnableFlag
                this.faceData.face1.objName = obj.objName
                break
              case this.faceData.face2.code:
                this.form.backId = obj.spaceId
                this.form.backMaterial = obj.objEnableFlag
                this.faceData.face2.objName = obj.objName
                break
              case this.faceData.face3.code:
                this.form.lumber1Id = obj.spaceId
                this.form.lumberMaterial1 = obj.objEnableFlag
                this.faceData.face3.objName = obj.objName
                break
              case this.faceData.face4.code:
                this.form.lumber2Id = obj.spaceId
                this.form.lumberMaterial2 = obj.objEnableFlag
                this.faceData.face4.objName = obj.objName
                break
              case this.faceData.face5.code:
                this.form.lumber3Id = obj.spaceId
                this.form.lumberMaterial3 = obj.objEnableFlag
                this.faceData.face5.objName = obj.objName
                break
              case this.faceData.face6.code:
                this.form.lumber4Id = obj.spaceId
                this.form.lumberMaterial4 = obj.objEnableFlag
                this.faceData.face6.objName = obj.objName
                break
              default:
            }
          })
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** 変更可能項目のチェック */
    checkDisableRadio: function (material, id) {
      return material === 9 || id === ''
    },
    /** 素材設定情報の更新 */
    updateMaterial: function () {
      let payload = this.form
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/material/update', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          this.$emit('closeTreeContextModal')
          this.modalShown = false
          AppUtil.showModal({
            messages: ['変更しました。']
          })
          this.$emit('setResponseData', response)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    /** パーツのプレビュー表示 */
    showPartsPreview: function () {
      // 上下(1),左右(2),前後(3)
      switch (this.dirAtt.attValue1) {
        case 1:
          this.previewData.width = this.selectedSpace.w
          this.previewData.height = this.selectedSpace.d
          break
        case 2:
          this.previewData.width = this.selectedSpace.d
          this.previewData.height = this.selectedSpace.h
          break
        case 3:
          this.previewData.width = this.selectedSpace.w
          this.previewData.height = this.selectedSpace.h
          break
        default:
      }
      this.calcPreviewRatio()
      this.previewData.width = this.previewData.width * this.previewRatio
      this.previewData.height = this.previewData.height * this.previewRatio
    },
    /** 縮尺率の計算 */
    calcPreviewRatio: function () {
      if (this.previewData.width > this.svgSize * 0.8 || this.previewData.height > this.svgSize * 0.8) {
        let widthRatio = this.svgSize / this.previewData.width
        let heightRatio = this.svgSize / this.previewData.height
        this.previewRatio = widthRatio > heightRatio ? heightRatio * 0.7 : widthRatio * 0.7
      } else {
        this.previewRatio = 0.8
      }
    },
    /** 木目マークに対応する数字の表示位置を設定 */
    createNumberList: function (isFirstFace) {
      let numberList = []
      let posX = (this.svgSize - this.previewData.width) / 2
      let posY = (this.svgSize - this.previewData.height) / 2
      let centerX = posX + this.previewData.width * 0.5 - this.fontSize / 2
      let centerY = posY + this.previewData.height * 0.5 + this.fontSize / 2
      if (isFirstFace) {
        // 表面
        numberList.push({label: '①', x: centerX, y: centerY})
      } else {
        // 裏面
        numberList.push({label: '②', x: centerX, y: centerY})
      }
      // 木口１
      numberList.push({label: '③', x: centerX, y: posY - 10})
      // 木口２
      numberList.push({label: isFirstFace ? '④' : '⑥', x: posX + this.previewData.width + 10, y: centerY})
      // 木口３
      numberList.push({label: '⑤', x: centerX, y: posY + this.previewData.height + (10 + this.fontSize)})
      // 木口４
      numberList.push({label: isFirstFace ? '⑥' : '④', x: posX - (10 + this.fontSize), y: centerY})
      return numberList
    },
    clearData: function () {
      this.form = {
        spaceId: '',
        surfaceId: '',
        surfaceMaterial: 0,
        backId: '',
        backMaterial: 0,
        lumber1Id: '',
        lumberMaterial1: 0,
        lumber2Id: '',
        lumberMaterial2: 0,
        lumber3Id: '',
        lumberMaterial3: 0,
        lumber4Id: '',
        lumberMaterial4: 0
      }
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.material-modal{
  max-height: 100%;
  min-width: 750px;
  max-width: 800px;
}
.main-area {
  max-height: 680px;
}
.data-area{
  margin: 20px auto;
  li{
    margin: 12px 0px;
    .label{
      min-width: 150px;
      display: inline-block;
      text-align: left;
    }
    .input{
      min-width: 140px;
      display: inline-block;
      text-align: left;
      label{
        min-width: 150px;
        text-align: left;
        padding: 0 10px;
        input[type="radio"]{
          margin: 0 3px;
        }
      }
    }
    input[type="number"]{
      width: 100px;
    }
    .input-size{
      display: inline-block;
      vertical-align: top;
      padding: 0 5px;
      .check{
        text-align: center;
      }
    }
  }
  .select-process {
    min-width: 200px;
  }
}
.errormessage-area{
  text-align: left;
  padding: 20px 75px;
}
.preview-area{
  margin: auto;
  .face-area{
    display: inline-block;
    .face-name{
      margin-bottom: 20px;
    }
  }
}
.error_messages{
  margin-left: auto;
  margin-right: auto;
  max-width: 270px;
  min-width: 270px;
}
.error_message {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetMaterialModal.vue